import Form from 'cerebral-module-forms/Form'

function prepareModuleFields({ state }) {
  let { modules, currentUser } = state.get('client')
  let options = {}
  modules.forEach(module => {
    options[module.module] = {
      options: [],
      value: [],
      type: 'select',
      isRequired: module.module === 'account',
      disabled: (currentUser && currentUser.useSSO) || false
    }
  })
  state.set('client.registrating.current.modules', Form(options))
}

export default prepareModuleFields



// WEBPACK FOOTER //
// ./src/modules/app/actions/prepareModuleFields.js